import { CMSData } from "@/cms/models";
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/sharp-light-svg-icons";
import SearchBarComponent from "./SearchBarComponent";
interface SearchBarProps {
  showSearch?: boolean;
  cmsData: CMSData;
  toggleSearch: () => void;
}

const SearchBar: React.FC<SearchBarProps> = ({
  showSearch,
  cmsData,
  toggleSearch,
}) => {
  return (
    <div
      className={`bg-[var(--search-bg-color)] text-[var(--search-text-color)] lg:flex fixed top-0 z-30 right-0 w-full shadow-lg transform ${
        showSearch ? "translate-y-0 opacity-100" : "-translate-y-full opacity-0"
      } transition duration-300 ease-in-out`}
    >
      <div className="flex flex-col flex-1 gap-2 p-4">
        <div className="flex justify-end flex-1">
          <button
            aria-label="Close"
            className="text-[var(--search-close-button-text-color)] p-2 flex"
            onClick={() => toggleSearch()}
          >
            <FontAwesomeIcon className="size-[32px]" icon={faClose} />
          </button>
        </div>
        <div className="flex flex-1 justify-center items-center">
          <div className="flex justify-center items-center w-[600px]">
            <SearchBarComponent
              config={{
                cmsData: cmsData,
                input: {
                  placeholderText:
                    "Søg på sagsnr., by vej, postnr eller kommune",
                },
              }}
              toggleSearch={toggleSearch}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SearchBar;
